import React from "react";
import "./teamblock.css";

const TeamBlock = ({
    image,
    name,
    role,
    description,
}) => {
    return (
        <div className="team-block-container">
            <div className="team-block-cnt">

                {/* Image */}
                <div className="tbc-img">
                    <img src={image} alt={name} />
                </div>

                {/* Content */}
                <div className="tbc-cnt">
                    <div className="tbc-title">
                        <h3>{name}</h3>
                        <span>{role}</span>
                    </div>

                    <div className="tbc-desc">
                        <p>{description}</p>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default TeamBlock;
